import { resolveIdentifiers, User } from "../model/model"
import { Transport, TransportRequest, TransportResponse } from "../transport/Transport"
import { UserTargetsResponseDto } from "./dto"
import { ApiCallMetrics } from "../metrics/monitoring/ApiCallMetrics"
import { UserTargets } from "./UserTarget"

export interface UserTargetFetcher {
  fetch(user: User): Promise<UserTargets>
}

export class BrowserUserTargetFetcher implements UserTargetFetcher {
  constructor(private readonly url: string, private readonly transport: Transport) {}

  async fetch(user: User): Promise<UserTargets> {
    const request = this.createRequest(user)
    const response = await this.execute(request)
    return this.handleResponse(response)
  }

  private createRequest(user: User): TransportRequest {
    const identifiers = { identifiers: resolveIdentifiers(user) }
    return TransportRequest.builder()
      .url(this.url)
      .method("POST")
      .addHeader("Content-Type", "text/plain;charset=UTF-8") // text/plain body to avoid CORS preflight
      .body(JSON.stringify(identifiers))
      .build()
  }

  private execute(request: TransportRequest): Promise<TransportResponse> {
    return ApiCallMetrics.record("get.user-targets", () => this.transport.send(request))
  }

  private handleResponse(response: TransportResponse): UserTargets {
    if (!response.isSuccessful()) {
      throw new Error(`Http status code: ${response.statusCode}`)
    }

    if (response.body === null) {
      throw new Error("Response body is null")
    }

    const dto = JSON.parse(response.body) as UserTargetsResponseDto
    return UserTargets.fromDto(dto)
  }
}
